import http from "../ http-common";
import store  from "../store";
const getBaseurl= () => {
  const state = store.getState();
  return state.server?.BASE_URL 
};
const getApibaseurl = () => {
  const state = store.getState();
  console.log("kjhgfdsadfgh uytfyguyi ",state.server?.API_BASE_URL );
  return state.server?.API_BASE_URL 
};
const API_BASE_URL = `${getApibaseurl()}/admin`;

class DocumentService {
  static async getDocumentPdfBlog(documentId) {
    var API_BASE_URL = getApibaseurl() + "/admin";
    return http.get(`${API_BASE_URL}/legalDocuments/${documentId}`, {
      responseType: "blob",
    });
  }
}

export default DocumentService;
